/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_BillingInputs */

const en_plan_no_billing = /** @type {(inputs: Plan_No_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No billing`)
};

const es_plan_no_billing = /** @type {(inputs: Plan_No_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin facturación`)
};

/**
* | output |
* | --- |
* | "No billing" |
*
* @param {Plan_No_BillingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_no_billing = /** @type {((inputs?: Plan_No_BillingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_BillingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_no_billing(inputs)
	return en_plan_no_billing(inputs)
});